import { render, staticRenderFns } from "./zhaoshengjianzhang.vue?vue&type=template&id=8d8767ec&scoped=true"
import script from "./zhaoshengjianzhang.vue?vue&type=script&lang=js"
export * from "./zhaoshengjianzhang.vue?vue&type=script&lang=js"
import style0 from "./zhaoshengjianzhang.vue?vue&type=style&index=0&id=8d8767ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8767ec",
  null
  
)

export default component.exports